import {onBeforeMount} from 'vue';
import {CoreGraphNodeId} from '../../../../../../@polygonjs/polygonjs/src/core/graph/CoreGraph';
import {SetupLinkIndexReturn} from '../../common/LinkIndex';
import {NodeDocsPanelInitLayoutData} from '../../../../types';
export interface NodeDocsPanelProps {
	panelId: string;
	nodeId: CoreGraphNodeId;
	init_layout_data: NodeDocsPanelInitLayoutData;
}

export function SetupLayoutData(props: NodeDocsPanelProps, setupLinkIndexReturn: SetupLinkIndexReturn) {
	onBeforeMount(() => {
		fromJSON(props.init_layout_data);
	});

	function fromJSON(json: NodeDocsPanelInitLayoutData) {
		setupLinkIndexReturn.fromJSON(json);
	}

	function layoutData() {
		return {
			...setupLinkIndexReturn.toJSON(),
		};
	}

	return {fromJSON, layoutData};
}
